/*!
 * Internal Component: SMB Subcategory Menu - Version: 1.3.37
 * Indeed - Copyright (c) 2023
 * This file is generated automatically. Do not edit.
 *
 * Contains sources adapted from Twitter Bootstrap v4.0.0-alpha.3, which are
 * licensed under MIT (https:
 */
let subMenus;
let subMenuToggles;
let overflowMenu;
function getSubmenuElements() {
  subMenus = document.querySelectorAll('.subnav-submenu');
  subMenuToggles = document.querySelectorAll('.subnav-submenu-toggle');
}
function toggleSubMenus() {
  subMenuToggles.forEach(function(toggle) {
    toggle.addEventListener('click', (e) => {
      const subMenuToggle = e.currentTarget;
      const subMenu = document.getElementById(subMenuToggle.getAttribute('aria-controls'));
      toggleWithAria(subMenuToggle, subMenu);
    });
  });
}
function closeOnFocusOutside() {
  const closeSubMenu = (subMenu, e) => {
    const subMenuToggle = document.querySelector(`[aria-controls=${subMenu.getAttribute('id')}]`);
    closeActiveSubMenu(subMenu, subMenuToggle, e, () => {
      subMenuToggle.setAttribute('aria-expanded', false);
      subMenu.setAttribute('aria-hidden', true);
    });
  };

  const closeOverflowMenu = (e) => {
    const overflowMenuToggle = overflowMenu.getNavElements()['toggle-btn'];
    const overflowMenuEl = overflowMenu.getNavElements()['overflow-nav'];
    closeActiveSubMenu(overflowMenuEl, overflowMenuToggle, e, () => overflowMenu.setOverflowNavOpen(false));
  };

  document.addEventListener('click', (e) => {
    subMenus.forEach((subMenu) => {
      closeSubMenu(subMenu, e);
    });

    closeOverflowMenu(e);
  }, true);

  document.addEventListener('keyup', (e) => {
    subMenus.forEach((subMenu) => {
      closeSubMenu(subMenu, e);
    });

    closeOverflowMenu(e);
  });
}
function closeActiveSubMenu(subMenu, subMenuToggle, e, menuCloseFn) {
    if (
      subMenu.getAttribute('aria-hidden') === 'false' && 
      e.target !== subMenuToggle &&                      
      ! subMenu.contains(e.target)                       
    ) {
    menuCloseFn();
  }
}
function toggleWithAria(toggle, target) {
  if (toggle.getAttribute('aria-expanded') === 'false') {
    toggle.setAttribute('aria-expanded', true);
    target.setAttribute('aria-hidden', false);
  } else {
    toggle.setAttribute('aria-expanded', false);
    target.setAttribute('aria-hidden', true);
  }
}
function priorityPlusInit() {
  if (typeof priorityPlus !== 'undefined') {
    overflowMenu = priorityPlus(document.querySelector('.subnav-menu-list'), {
      classNames: {
        'toggle-btn': ['p-plus__toggle-btn', 'subnav-overflow-toggle'],
        'overflow-nav': ['subnav-overflow-list']
      },
      innerToggleTemplate: ({ toggleCount, totalCount }) => `
        <span class="subnav-overflow-toggle-label">
          ${toggleCount && toggleCount === totalCount ? hireResourcesLinkLabel : overflowMenuToggleLabel}
        </span>
        <img class="subnav-caret" src="https://d341ezm4iqaae0.cloudfront.net/assets/2022/05/23182052/opt-caret-down1-1.svg" alt="" />
      `,
    });
  }
}
document.addEventListener('DOMContentLoaded', () => {
    priorityPlusInit();
    getSubmenuElements();
    toggleSubMenus();
    closeOnFocusOutside();
    document.querySelector('.subnav-menu').style.visibility = "visible";
});
const hireTranslations = [
  'hire',
  'εταιρείες', 
  '%CE%B5%CF%84%CE%B1%CE%B9%CF%81%CE%B5%CE%AF%CE%B5%CF%82', 
  'работодатель', 
  '%D1%80%D0%B0%D0%B1%D0%BE%D1%82%D0%BE%D0%B4%D0%B0%D1%82%D0%B5%D0%BB%D1%8C', 
  'التوظيف', 
  '%D8%A7%D9%84%D8%AA%D9%88%D8%B8%D9%8A%D9%81', 
  'รับสมัครงาน', 
  '%E0%B8%A3%E0%B8%B1%E0%B8%9A%E0%B8%AA%E0%B8%A1%E0%B8%B1%E0%B8%84%E0%B8%A3%E0%B8%87%E0%B8%B2%E0%B8%99', 
  '徵才', 
  '%E5%BE%B5%E6%89%8D', 
  '招聘', 
  '%E6%8B%9B%E8%81%98', 
  '求人広告', 
  '%E6%B1%82%E4%BA%BA%E5%BA%83%E5%91%8A', 
  '인재채용', 
  '%EC%9D%B8%EC%9E%AC%EC%B1%84%EC%9A%A9', 
  'eleman-bul', 
  'hr', 
  'nábor-zaměstnanců', 
  'n%C3%A1bor-zam%C4%9Bstnanc%C5%AF', 
  'personeel', 
  'perusahaan', 
  'reclutamiento', 
  'recruiting', 
  'recruitment', 
  'recrutamento', 
  'recrutare', 
  'recrutement', 
  'rekrutacja', 
  'rekruttering', 
  'rekrytera', 
  'rekrytoi', 
  'toborzás', 
  'toborz%C3%A1s', 
  'tuyển-dụng', 
  'tuy%E1%BB%83n-d%E1%BB%A5ng' 
];
const titleCurrencyCharsToFilter = [
    '$',
    '£',
    '€',
    '¥',
    '₹',
];
const excludeHirePathPrefixes = [
    'directmail',
    'sem-haj',
    'acq-',
];
const excludeHirePaths = [
    'pub-credit',  
    '100radio', 
    'credit50', 
    'hiretoday', 
    'onboarding-webinar-promo', 
    'smbacq_email_0723_75', 
    'mmacq_email_0723_200', 
    'mid-market-acquisition-wd-cold-email-feb-2023-200-credit', 
    'mid-market-acquisition-wd-cold-email-jun-2023-200-credit', 
    'courrier1', 
    'solution', 
    'offre',  
    'publier-une-annonce-tlmkg', 
    'trophees-pme-rmc', 
    'mmacq_email_0923_100', 
];
function appendParamsOnce(url, params) {
    var useParams = params.replace(/^(\?|\&)/, '');
    var anchorRegExp = new RegExp(/#.*$/);
    var urlAnchorMatch = url.match(anchorRegExp);

    var anchor = urlAnchorMatch == null ? '' : urlAnchorMatch;
    url = url.replace(anchorRegExp, '');

    if (url.match(new RegExp('[\\?|\\&]' + regExpEscape(useParams))) == null) {
        url += (url.indexOf('?') > 0 ? '&' : '?') + useParams;
    }
    url += anchor;

    return url;
}
function regExpEscape(s) {
    return String(s).replace(/([-()\[\]{}+?*.$\^|,:#<!\\])/g, '\\\$1').
    replace(/\x08/g, '\\x08');
}
function formatSitemapTitle(titleText) {
  return titleText.replace(/ ?\[Update.*\] ?/g, '').replace(/ ?\|[\s\S]*/g, '');
}
function calcSitemapElementsArrayFromText(sitemapPageText) {
    const parser = new DOMParser();
    const sitemapHtmlDoc = parser.parseFromString(sitemapPageText, 'text/html');
    const sitemapContentsDiv = sitemapHtmlDoc.getElementById('sitemap');
    if (!sitemapContentsDiv) {
        console.log('Could not parse data from sitemap, may be 404.');
        return [];
    }

    const sitemapEntries = sitemapContentsDiv.getElementsByTagName('a');
    const siteMapEntriesArray = [...sitemapEntries];
    const indexPageEntries = siteMapEntriesArray.filter((el) => new URL(el.href).pathname.split('/').length <= 3);
    const otherEntries = siteMapEntriesArray.filter((el) => new URL(el.href).pathname.split('/').length > 3);
    return [...indexPageEntries, ...otherEntries];
}
function calcSitemapArrayFromElementsArray(sitemapElementsArray) {
    return sitemapElementsArray.map(el => ({title: formatSitemapTitle(el.innerHTML), url: el.href}));
}

let sitemapPageTextPromise = null;  
function fetchSitemapText() {
    if (!sitemapPageTextPromise) {
        console.log('Loading sitemap for search query data, subnavSearchSitemapUrl:', subnavSearchSitemapUrl);
        sitemapPageTextPromise = fetch(subnavSearchSitemapUrl).then(function(response) {
            return response.text();
        }).catch(function(e) {
            console.log("Failed to load sitemap", e);
            return null;
        });
    }
    return sitemapPageTextPromise;
}

function shouldIncludeSitemapObj(sitemapObj) {
    const path = new URL(sitemapObj.url).pathname.split('/');
    if (
        !hireTranslations.includes(path[1]) &&
        !(path[1] === 'employers' && (subnavSearchSitemapLocale === 'en_LU' || subnavSearchSitemapLocale === 'en_MY'))
    ) {
        return false;
    }
    if (path.length < 2 || path.length > 0 && path[0] !== '') {
        return false;
    }
    if (path.length == 2) {
        return true;
    }
    if (path.length == 3 && (path[2] === 'sitemap' || path[2] === 'cookie')) {
        return false;
    }
    if (path.length == 4 && (path[2] === 'internal-components' && path[3] === 'smb-subcategory-menu')) {
        return false;
    }
    for (const currencyChar of titleCurrencyCharsToFilter) {
        if (sitemapObj.title.includes(currencyChar)) {
            return false;
        }
    }
    for (const excludePrefix of excludeHirePathPrefixes) {
        if (path[2].startsWith(excludePrefix)) {
            return false;
        }
    }
    const pathSectionsAfterFirst = path.slice(2, undefined).join('/');
    const isExcludedHirePath = excludeHirePaths.includes(pathSectionsAfterFirst);
    return !isExcludedHirePath;
}

function filterSitemapArray(sitemapArray) {
    return sitemapArray.filter(shouldIncludeSitemapObj);
}

let sitemapObjListPromise = null; 
function fetchSitemapAsObjList() {
    if (!sitemapObjListPromise) {
        sitemapObjListPromise = fetchSitemapText().then(function (sitemapText) {
            console.log('Converting sitemap text to list of objects.');
            const sitemapElementsArray = calcSitemapElementsArrayFromText(sitemapText);
            const sitemapArray = calcSitemapArrayFromElementsArray(sitemapElementsArray);
            return filterSitemapArray(sitemapArray);
        });
    }
    return sitemapObjListPromise;
}
function displaySuggestion(sitemapPage) {
    let url = new URL(sitemapPage.url);

    if (typeof subnavSearchSourceId === 'string' && subnavSearchSourceId.trim()) {
        url.searchParams.set("isid", subnavSearchSourceId);
        url.searchParams.set("ikw", "subnav_search_ikw");
    }
    return `<div><a tabindex="-1" href="${url.href}">${sitemapPage.title}</a></div>`;
}
function displaySuggestionsHeading() {
    return `<div class="custom-tt-header">${subnavSearchSuggestionsHeading}</div>`;
}

let addedToBloodhound = false;  
function searchInputTypeaheadInit() {
    if (!window.Bloodhound) {
      return;
    }
    const bloodhound = new Bloodhound({
        datumTokenizer: Bloodhound.tokenizers.obj.whitespace('title'),
        queryTokenizer: Bloodhound.tokenizers.whitespace,
        identify: function(sitemapPageObj) { return sitemapPageObj.title; },
    });
    const subnavSeachInputJQuery = subnavJQuery('#subnav-search-input');

    if (!subnavSeachInputJQuery.length) {
        return;
    }

    subnavSeachInputJQuery.typeahead({
        highlight: true,
        hint: true,
        minLength: 3,
    }, {
        name: 'sitemap',
        limit: 6,
        async: true,
        source: bloodhound,
        display: 'title',
        templates: {
            suggestion: displaySuggestion,
            header: displaySuggestionsHeading,
        },
    }).on('typeahead:select', function(ev, selection) {
        location.href = selection.url;
    }).on('typeahead:active', function(ev) {
        fetchSitemapAsObjList().then(function(sitemapObjList) {
            if (!addedToBloodhound) {
                addedToBloodhound = true;
                console.log('Fetched search data from sitemap, adding to Bloodhound.');
                bloodhound.add(sitemapObjList);
                const currentVal = subnavSeachInputJQuery.typeahead('val');
                subnavSeachInputJQuery.typeahead('val', '');
                subnavSeachInputJQuery.typeahead('val', currentVal);
            }
        });
    });
}
window.addEventListener('load', searchInputTypeaheadInit);

const searchBoxQ = () => document.querySelector('.search-box');
const toggleSearchButtonQ = () => document.querySelector('.toggle-search');
const clearInputButtonQ = () => document.querySelector('.clear-input-button');
const searchInputQ = () => document.querySelector('#subnav-search-input');  

function searchBoxInit() {
    const searchBox = searchBoxQ();
    const toggleSearchButton = toggleSearchButtonQ();
    const clearInputButton = clearInputButtonQ();
    const searchInput = searchInputQ();

    if (searchBox && toggleSearchButton && clearInputButton && searchInput) {
      searchBox.addEventListener('keydown', handleEscapeKeyClose);
      toggleSearchButton.addEventListener('keydown', handleEscapeKeyClose);
      toggleSearchButton.addEventListener('click', toggleSearchBox);
      clearInputButton.addEventListener('click', clearInput);
      searchInput.addEventListener('input', onInputChange);
    }
}
window.addEventListener('load', searchBoxInit);

function toggleSearchBox() {
    const searchBox = searchBoxQ();
    const searchInput = searchInputQ();
    const toggleSearchButton = toggleSearchButtonQ();
    if(!searchBox.classList.contains('displayed')) {
        searchBox.classList.add('displayed');
        toggleSearchButton.classList.add('enabled');
        searchInput.focus();
        document.addEventListener('click', handleDocumentClick);
    } else {
        closeSearch();
    }
}

function closeSearch() {
    const toggleSearchButton = toggleSearchButtonQ();
    const searchBox = searchBoxQ();
    document.removeEventListener('click', handleDocumentClick);

    searchBox.classList.remove('displayed');
    toggleSearchButton.classList.remove('enabled');
}

function handleEscapeKeyClose(event) {
    if (event.key === 'Escape') {
        closeSearch();
    }
}

function handleDocumentClick(event) {
    if(!event.target.closest(".search-container")){
        closeSearch();
    }
}

function onInputChange() {
    const clearInputButton = clearInputButtonQ();

    const currentVal = subnavJQuery('#subnav-search-input').typeahead('val');
    if(currentVal) {
        clearInputButton.classList.add('displayed');
    } else {
        clearInputButton.classList.remove('displayed');
    }
}

function clearInput() {
    const searchInput = searchInputQ();
    const clearInputButton = clearInputButtonQ();
    searchInput.focus();
    clearInputButton.classList.remove('displayed');
    subnavJQuery('#subnav-search-input').typeahead('val', '');
}

